/* eslint-disable */
// import Libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Modal } from 'antd';
import _ from "lodash";
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import SelectDropdown from '../../../legacy/components/SelectDropdown'
import MenuItem from '@material-ui/core/MenuItem';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';



// import custom Components
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar';
import ContentHeader from 'legacy/containers/ContentHeader';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import EcgLoader from 'legacy/containers/EcgLoader';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { checkIdtfServiceProviderFeatureEnabled } from 'configs';

import KardiaRxCCTWorkListResult from '../../containers/KardiaRxCCTWorkListResult';
import {
  getKardiaRxCCTWorklistData,
  handleOnRefreshClick,
  searchClear,
  getKardiaRxCCTWorklistDataPaginationPrevious,
  paginationTokenClear,
  practiceIdUpdate,
  providerIdUpdate,
  reRouteErrorClear,
  handleOkForSendToArchive,
} from '../../state/kardiaRxCCTWorklist/KardiaRxCCTWorklistActions';
import WorklistSearchBar from '../../containers/WorkListSearch/PatientSearchBar';
import Paginator from '../../components/Table/Paginator';

// import css
import styles from './KardiaRxCCTWorkList.css';
import AlertModal from '../../components/Common/AlertModal';

/**
 * Page - KardiaRx (Side-Nav)
 *
 */

const tableListHeader = {
  '1': 'Triage',
  '2': 'Analysis',
  '3': 'QA',
  '4': 'Completed Events',
  '5': 'Archive',
};
class KardiaRxCCTWorkList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      perPage: 100,
      providerValue: null,
    };
  }

  componentDidMount() {
    this.props.paginationTokenClear();
    this.props.searchClear();
    this.props.getKardiaRxCCTWorklistData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { CCT_DROPDOWN_VALUE } = this.props;
    if (
      CCT_DROPDOWN_VALUE &&
      prevProps.CCT_DROPDOWN_VALUE !== CCT_DROPDOWN_VALUE
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        currentPage: 1,
      });
    }
  }

  handlePageChange = (page, action = 'click') => {
    const { CCT_WORK_LIST_STATE, paginationTokenClear, getKardiaRxCCTWorklistData, CCT_DROPDOWN_VALUE, getKardiaRxCCTWorklistDataPaginationPrevious } = this.props;
    const { currentPage } = this.state;
    if (page === 1) {
      paginationTokenClear();
      this.setState(
        {
          currentPage: page,
        },
        () => {
          getKardiaRxCCTWorklistData(
            false,
            CCT_DROPDOWN_VALUE ? CCT_DROPDOWN_VALUE : 1,
            100,
            page,
          );
        },
      );

    } else if (page > this.props.pageNo) {
      this.setState(
        {
          currentPage: page,
        },
        () => {
          getKardiaRxCCTWorklistData(
            false,
            CCT_DROPDOWN_VALUE ? CCT_DROPDOWN_VALUE : 1,
            100,
            page,
            CCT_WORK_LIST_STATE.paginationToken[page - 2]
          );
        },
      );
    } else {
      this.setState(
        {
          currentPage: page,
        },
        () => {
          getKardiaRxCCTWorklistDataPaginationPrevious(
            false,
            CCT_DROPDOWN_VALUE ? CCT_DROPDOWN_VALUE : 1,
            100,
            page,
            CCT_WORK_LIST_STATE.paginationToken[page - 2]
          );
        },
      );
    }

  };

  handleRefresh = () => {
    this.setState({
      currentPage: 1,
    });
    return this.props.refreshData();
  };

  handlePracticeDropdown = (item) => {
    if (item) {
      this.props.practiceIdUpdate(item.team_id)
    } else {
      this.props.practiceIdUpdate(null)
      this.props.providerIdUpdate(null)
      this.setState({
        providerValue: null
      })
      // let InputClear = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
      // if (InputClear) {
      //   InputClear.click();
      // }
    }

    this.props.getKardiaRxCCTWorklistData(false, this.props.CCT_DROPDOWN_VALUE ? this.props.CCT_DROPDOWN_VALUE : 1, 100, 1, '');
  }

  handleProviderDropdown = (item) => {
    this.setState({
      providerValue: item
    })
    if (item) {
      this.props.providerIdUpdate(item.member_id)
    } else {
      this.props.providerIdUpdate(null)
    }
    this.props.getKardiaRxCCTWorklistData(false, this.props.CCT_DROPDOWN_VALUE ? this.props.CCT_DROPDOWN_VALUE : 1, 100, 1, '');
  }


  handleOk = () => {
    console.log("okkkkkkkkkk");
    this.props.handleOkForSendToArchive()
    // setIsModalVisible(false);
  };

  handleCancel = () => {
    console.log("cancel");
    this.props.reRouteErrorClear();
  };

  handleSendToChange = (e) => {
    console.log("handle change", e.target.value);
  }

  render() {
    const {
      me,
      intl,
      refreshData,
      CCT_WORK_LIST_STATE,
      CCT_DROPDOWN_VALUE,
    } = this.props;

    const totalCount =
      CCT_WORK_LIST_STATE &&
      CCT_WORK_LIST_STATE.recordings &&
      CCT_WORK_LIST_STATE.recordings.data &&
      CCT_WORK_LIST_STATE.recordings.data.count;
    const recordLenth =
      CCT_WORK_LIST_STATE &&
      CCT_WORK_LIST_STATE.recordings &&
      CCT_WORK_LIST_STATE.recordings.data &&
      CCT_WORK_LIST_STATE.recordings.data.items &&
      CCT_WORK_LIST_STATE.recordings.data.items.length;

    if (!checkIdtfServiceProviderFeatureEnabled(me)) {
      return (
        <ContentWithNavigationSidebar>
          <div data-page="kardiaRxCct" className={styles.KardiaRxCctPage}>
            <AccessDeniedContent text="Work List" />
          </div>
        </ContentWithNavigationSidebar>
      );
    }
    return (
      <ContentWithNavigationSidebar>
        <div data-page="kardiaRxCct" className={styles.KardiaRxCctPage}>
          <ContentHeader
            isLoading={me.isFetching}
            showLastRefresh={!me.isFetching}
            lastUpdated={CCT_WORK_LIST_STATE.recordings.dataLastUpdated}
            handleOnRefreshClick={this.handleRefresh}
            text="Work List"
            me={me}
            showAddPatient={false}
          />
          <React.Fragment>
            <div className={styles.patientSearchBar}>
              <WorklistSearchBar />
              <div className={styles.KardiaRxCctSecondaryFilter}>
                <div style={{ width: '47%' }}>
                  <SelectDropdown
                    isClearable={true}
                    backspaceRemovesValue={true}
                    placeholder="Practice Name"
                    options={_.uniqBy(
                      this.props.worklistPracticeAutoCompleteSearch,
                      function(e) {
                        return e.team_id;
                      },
                    )}
                    onChange={this.handlePracticeDropdown}
                    noOptionsMessage="No Practice found"
                    getOptionLabel={option => option.teamName}
                    getOptionValue={p => p.team_id}
                    className="practiceSelect react-select-filter-selector"
                  />
                </div>
                {/* <Autocomplete
                  id="combo-box-practice"

                  options={_.uniqBy(this.props.worklistPracticeAutoCompleteSearch, function (e) {
                    return e.team_id;
                  })}
                  getOptionLabel={(option) => option.teamName}
                  style={{ width: '47%' }}
                  onChange={this.handlePracticeDropdown}
                  renderInput={(params) => <TextField {...params} variant="standard" size="small" placeholder="Practice Name" variant="outlined" />}
                /> */}
                <div style={{ width: '47%' }}>
                  <SelectDropdown
                    disabled={this.props.practiceId ? false : true}
                    isClearable={true}
                    backspaceRemovesValue={true}
                    placeholder="Provider Name"
                    value={this.state.providerValue}
                    options={_.uniqBy(
                      this.props.worklistProviderAutoCompleteSearch,
                      function(e) {
                        return e.member_id;
                      },
                    )}
                    onChange={this.handleProviderDropdown}
                    noOptionsMessage="No Provider found"
                    getOptionLabel={option => option.name}
                    getOptionValue={p => p.member_id}
                    className="providerSelect react-select-filter-selector"
                  />
                </div>
                {/* <Autocomplete
                  id="combo-box-provider"
                  disabled={this.props.practiceId ? false : true}
                  options={_.uniqBy(this.props.worklistProviderAutoCompleteSearch, function (e) {
                    return e.member_id;
                  })}
                  // inputValue="sumit"
                  getOptionLabel={(option) => option.name}
                  style={{ width: '47%' }}
                  onChange={this.handleProviderDropdown}
                  renderInput={(params) => <TextField {...params} variant="standard" size="small" placeholder="Provider Name" variant="outlined" />}
                /> */}
              </div>
            </div>
            <React.Fragment>
              <div className={styles.KardiaRxCctContainer}>
                <div className={styles.KardiaRxCctTableHeading}>
                  {CCT_DROPDOWN_VALUE
                    ? tableListHeader[`${CCT_DROPDOWN_VALUE}`]
                    : tableListHeader['1']}
                </div>
                <div className={styles.kardiaPaginator}>
                  <div style={{ marginLeft: 20 }}>
                    {' '}
                    SHOWING {recordLenth} OF {totalCount}{' '}
                  </div>
                  <div style={{ marginBottom: 5 }}>
                    <Paginator
                      isLoading={CCT_WORK_LIST_STATE.recordings.isFetching}
                      currentPage={this.props.pageNo}
                      perPage={this.state.perPage}
                      totalRecords={
                        CCT_WORK_LIST_STATE &&
                        CCT_WORK_LIST_STATE.recordings &&
                        CCT_WORK_LIST_STATE.recordings.data &&
                        CCT_WORK_LIST_STATE.recordings.data.count
                      }
                      onPageChange={this.handlePageChange}
                    />
                  </div>
                </div>
                {!CCT_WORK_LIST_STATE.recordings.isFetching &&
                  CCT_WORK_LIST_STATE.routedToAnnotationPageError && (
                    <div>
                      <Modal
                        title="Corrupted data or missing value"
                        visible={
                          CCT_WORK_LIST_STATE.routedToAnnotationPageError
                        }
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                      >
                        <FormLabel className={styles.labaleFixedWidth}>
                          <p style={{ fontSize: '0.87rem' }}>Send To:</p>
                        </FormLabel>
                        <FormControl className={styles.formFieldSelect}>
                          <Select
                            labelId="send-to-label"
                            id="send-to"
                            value="5"
                            onChange={this.handleSendToChange}
                          >
                            <MenuItem value={5}>Archive</MenuItem>
                          </Select>
                        </FormControl>
                      </Modal>
                    </div>
                  )}
                {CCT_WORK_LIST_STATE.recordings.isFetching ? (
                  <EcgLoader />
                ) : (
                  <KardiaRxCCTWorkListResult />
                )}
              </div>
            </React.Fragment>
          </React.Fragment>
        </div>
      </ContentWithNavigationSidebar>
    );
  }
}

KardiaRxCCTWorkList.contextType = UserProfileContext;
const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const CCT_WORK_LIST_STATE = state.kardiaRx.kardiaRxCCTWorklist;
  const CCT_DROPDOWN_VALUE =
    state.kardiaRx.kardiaRxCCTWorklist.selectedFilterDropdown;
  const pageNo = state.kardiaRx.kardiaRxCCTWorklist.pageNo;
  const worklistPracticeAutoCompleteSearch = state.kardiaRx.kardiaRxCCTWorklist.worklistPracticeAutoCompleteSearch;
  const worklistProviderAutoCompleteSearch = state.kardiaRx.kardiaRxCCTWorklist.worklistProviderAutoCompleteSearch
  const practiceId = state.kardiaRx.kardiaRxCCTWorklist.practiceId
  const routedToAnnotationPageError = state.kardiaRx.kardiaRxCCTWorklist.routedToAnnotationPageError

  // const { form, search } = state;
  return {
    me,
    CCT_WORK_LIST_STATE,
    CCT_DROPDOWN_VALUE,
    pageNo,
    worklistPracticeAutoCompleteSearch,
    worklistProviderAutoCompleteSearch,
    practiceId
  };
};

const mapActionCreators = {
  getKardiaRxCCTWorklistData,
  refreshData: handleOnRefreshClick,
  searchClear,
  getKardiaRxCCTWorklistDataPaginationPrevious,
  paginationTokenClear,
  practiceIdUpdate,
  providerIdUpdate,
  reRouteErrorClear,
  handleOkForSendToArchive,
};
export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxCCTWorkList));


// WEBPACK FOOTER //
// ./src/views/pages/KardiaRxCCTWorkList/KardiaRxCCTWorkList.jsx